import React from 'react'

import { FaPause, FaPlay } from 'react-icons/fa'

import {
  CategoryButton,
  CategoryList,
  PlaylistHeader,
  PlaylistPanel,
  TrackButton,
  TrackCover,
  TrackDetails,
  TrackList,
} from './styles'

import type { RoutineCategoryOption, RoutinePlaylistItem } from './types'

interface RoutinePlaylistProps {
  categories: RoutineCategoryOption[]
  items: RoutinePlaylistItem[]
  onCategorySelect: (index: number) => void
  onTrackSelect: (index: number) => void
}

const RoutinePlaylist = ({
  categories,
  items,
  onCategorySelect,
  onTrackSelect,
}: RoutinePlaylistProps) => (
  <PlaylistPanel>
    <PlaylistHeader>
      <div>
        <span>Tu entrenamiento</span>
        <h3>Elige qué quieres practicar</h3>
      </div>
      <small>{`${items.length} ${items.length === 1 ? 'ejercicio' : 'ejercicios'}`}</small>
    </PlaylistHeader>
    <CategoryList aria-label="Categorías de la rutina">
      {categories.map((category) => (
        <CategoryButton
          key={category.id}
          type="button"
          $active={category.active}
          aria-pressed={category.active}
          onClick={() => onCategorySelect(category.index)}
        >
          <span>{category.label}</span>
        </CategoryButton>
      ))}
    </CategoryList>
    <TrackList aria-label="Ejercicios disponibles">
      {items.map((item) => (
        <TrackButton
          key={item.id}
          type="button"
          $active={item.playing}
          aria-current={item.playing ? 'true' : undefined}
          onClick={() => onTrackSelect(item.index)}
        >
          <strong>{String(item.index + 1).padStart(2, '0')}</strong>
          <TrackCover src={item.artwork} alt="" />
          <TrackDetails className="track-details">
            <span>{item.label}</span>
            <small>{item.category}</small>
          </TrackDetails>
          <span className="track-action">
            {item.playing ? (
              <FaPause aria-hidden="true" />
            ) : (
              <FaPlay aria-hidden="true" />
            )}
          </span>
        </TrackButton>
      ))}
    </TrackList>
  </PlaylistPanel>
)

export default RoutinePlaylist
